import React from 'react'

const Footer = () => {
  return (
    <footer className='footer'>
      © MemoWrite 2023. Developed by srijan :)
    </footer>
  )
}

export default Footer
